import React from 'react';
import { IconsPros } from '../icons/types';

/**
 * ConstantContact Logo component
 *
 * @returns JSX.ELEMENT
 */
export const ConstantContactLogo = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 82 56" data-testid={dataTestId}>
      <linearGradient
        id="v"
        x1="-346.66"
        x2="-344.16"
        y1="492.07"
        y2="492.07"
        gradientTransform="matrix(90.294 0 0 -78.174 31629 38505)"
      >
        {' '}
        <stop stopColor="#164989" offset="0" /> <stop stopColor="#1e446d" offset="1" />{' '}
      </linearGradient>
      <path
        className="st0"
        d="M36.5 31.2C32.2 32.4 28 34 24 35.8c-1 2.8-1.8 5.6-2.4 8.3h.1c4.1-1.4 8.4-2.6 12.6-3.4.5-3.2 1.3-6.4 2.2-9.5z"
        fill="url(#v)"
      />
      <linearGradient
        id="u"
        x1="-334.76"
        x2="-332.26"
        y1="521.54"
        y2="521.54"
        gradientTransform="matrix(40.3 0 0 -48.763 13500 25482)"
      >
        {' '}
        <stop stopColor="#fde1a4" offset="0" /> <stop stopColor="#fac654" offset="1" />{' '}
      </linearGradient>
      <path
        className="st1"
        d="m9.9 43.9c-2.6 1.9-5.2 3.9-7.6 6.1l-2.4 6c2.5-2 5.2-3.9 8-5.6l2-6.5z"
        fill="url(#u)"
      />
      <linearGradient
        id="t"
        x1="-349.11"
        x2="-346.71"
        y1="485.14"
        y2="485.14"
        gradientTransform="matrix(118.67 0 0 -86.75 42087 42120)"
      >
        {' '}
        <stop stopColor="#f7b219" offset="0" /> <stop stopColor="#dd8f27" offset="1" />{' '}
      </linearGradient>
      <path
        className="st2"
        d="M53.2 27.9h-.3l-3.5.4c-3.7.5-7.3 1.3-10.9 2.3-1 3.2-1.8 6.5-2.4 9.8l6-.8c3-.3 6.1-.5 9.2-.6.4-3.7 1.1-7.5 1.9-11.1z"
        fill="url(#t)"
      />
      <linearGradient
        id="s"
        x1="-353.6"
        x2="-351.1"
        y1="473.39"
        y2="473.39"
        gradientTransform="matrix(196.46 0 0 -116.09 70845 54963)"
      >
        {' '}
        <stop stopColor="#f7b219" offset="0" /> <stop stopColor="#dd8f27" offset="1" />{' '}
      </linearGradient>
      <path
        className="st3"
        d="M76.3 12c1.6-4.1 3.5-8.1 5.7-12h-.7c-5.4.3-10.8 1-16 2.1-2 3.5-3.7 7.2-5.3 10.9 5-.8 10-1.2 15-1.2h1.3v.2z"
        fill="url(#s)"
      />
      <linearGradient
        id="r"
        x1="-351.64"
        x2="-349.14"
        y1="477.48"
        y2="477.48"
        gradientTransform="matrix(162.2 0 0 -98.942 58189 47263)"
      >
        {' '}
        <stop stopColor="#8aa4c4" offset="0" /> <stop stopColor="#6d8cb5" offset="1" />{' '}
      </linearGradient>
      <path
        className="st4"
        d="M59.1 15c-1.4 3.6-2.6 7.2-3.6 10.9h.1c5.3-.5 10.7-.5 16-.1 1.2-4.3 2.5-8.3 3.9-12.1h-.7c-5.2 0-10.5.4-15.7 1.3z"
        fill="url(#r)"
      />
      <linearGradient
        id="q"
        x1="-341.37"
        x2="-338.87"
        y1="503.67"
        y2="503.67"
        gradientTransform="matrix(62.124 0 0 -65.631 21396 33089)"
      >
        {' '}
        <stop stopColor="#f7b219" offset="0" /> <stop stopColor="#dd8f27" offset="1" />{' '}
      </linearGradient>
      <path
        className="st5"
        d="m25.9 26.5c-3 1.7-6.1 3.6-9 5.6-1.2 2.5-2.4 5-3.4 7.5 2.9-1.8 6-3.5 9.1-4.9 1-2.9 2.1-5.6 3.3-8.2z"
        fill="url(#q)"
      />
      <linearGradient
        id="p"
        x1="-332.77"
        x2="-330.27"
        y1="522.18"
        y2="522.18"
        gradientTransform="matrix(37.927 0 0 -46.529 12658 24337)"
      >
        {' '}
        <stop stopColor="#164989" offset="0" /> <stop stopColor="#1e446d" offset="1" />{' '}
      </linearGradient>
      <path
        className="st6"
        d="m13.9 34.1l-5.4 4.2c-1.6 2.5-3 5.1-4.3 7.7 2.1-1.8 4.4-3.5 6.7-5l3-6.9z"
        fill="url(#p)"
      />
      <linearGradient
        id="o"
        x1="-351.1"
        x2="-348.6"
        y1="479.65"
        y2="479.65"
        gradientTransform="matrix(146.5 0 0 -108.15 52338 51882)"
      >
        {' '}
        <stop stopColor="#164989" offset="0" /> <stop stopColor="#1e446d" offset="1" />{' '}
      </linearGradient>
      <path
        className="st7"
        d="M43.9 16.8c4.1-1.3 8.2-2.3 12.5-3.1l1.5-.3c1.5-3.7 3.2-7.3 5.1-10.7-4.6 1.1-9.1 2.5-13.5 4.1-2.1 3.3-3.9 6.6-5.6 10z"
        fill="url(#o)"
      />
      <linearGradient
        id="n"
        x1="-347.93"
        x2="-345.43"
        y1="488.42"
        y2="488.42"
        gradientTransform="matrix(101.28 0 0 -88.458 35640 43231)"
      >
        {' '}
        <stop stopColor="#8aa4c4" offset="0" /> <stop stopColor="#6d8cb5" offset="1" />{' '}
      </linearGradient>
      <path
        className="st8"
        d="M40.7 19.8c-4.2 1.5-8.3 3.3-12.2 5.3-1.3 2.7-2.5 5.6-3.6 8.5 4-1.7 8.1-3.2 12.3-4.4.9-3.2 2.1-6.3 3.5-9.4z"
        fill="url(#n)"
      />
      <linearGradient
        id="m"
        x1="-343.4"
        x2="-340.9"
        y1="497.6"
        y2="497.6"
        gradientTransform="matrix(72.494 0 0 -74.117 25154 36902)"
      >
        {' '}
        <stop stopColor="#fde1a4" offset="0" /> <stop stopColor="#fac654" offset="1" />{' '}
      </linearGradient>
      <path
        className="st9"
        d="m32 15.1c-2.7 1.5-5.3 3.2-7.9 4.9-2 2.8-3.8 5.8-5.5 8.8 2.8-1.8 5.6-3.4 8.5-5 1.5-3 3.1-5.9 4.9-8.7z"
        fill="url(#m)"
      />
      <linearGradient
        id="l"
        x1="-350.05"
        x2="-347.65"
        y1="482.55"
        y2="482.55"
        gradientTransform="matrix(129.95 0 0 -96.558 46243 46616)"
      >
        {' '}
        <stop stopColor="#fde1a4" offset="0" /> <stop stopColor="#fac654" offset="1" />{' '}
      </linearGradient>
      <path
        className="st10"
        d="M42.9 19c-1.4 3.1-2.7 6.3-3.8 9.6v.1c4.8-1.1 9.6-2 14.5-2.5 1-3.7 2.1-7.3 3.4-10.8l-.4.1c-4.6.8-9.2 2-13.7 3.5z"
        fill="url(#l)"
      />
    </svg>
  );
};
